import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_1/BuildingInstructions_Images/ExplorationModels`

const Pic1 = `${FullPath}/DoubleSpeedReductionTransmission/1_1x.png`;
const Pic2 = `${FullPath}/DoubleSpeedReductionTransmission/2_1x.png`;
const Pic3 = `${FullPath}/DoubleSpeedReductionTransmission/3_1x.png`;
const Pic4 = `${FullPath}/DoubleSpeedReductionTransmission/4_1x.png`;
const Pic5 = `${FullPath}/DoubleSpeedReductionTransmission/5_1x.png`;
const Pic6 = `${FullPath}/DoubleSpeedReductionTransmission/6_1x.png`;
const Pic7 = `${FullPath}/DoubleSpeedReductionTransmission/7_1x.png`;
const Pic8 = `${FullPath}/DoubleSpeedReductionTransmission/8_1x.png`;
const Pic9 = `${FullPath}/DoubleSpeedReductionTransmission/9_1x.png`;
const Pic10 = `${FullPath}/DoubleSpeedReductionTransmission/10_1x.png`;
const Pic11 = `${FullPath}/DoubleSpeedReductionTransmission/11_1x.png`;
const Pic12 = `${FullPath}/DoubleSpeedReductionTransmission/12_1x.png`;
const Pic13 = `${FullPath}/DoubleSpeedReductionTransmission/13_1x.png`;




export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
        Pic13,
    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}